import { PlatformSettings } from '@wellesley/openapi'

export const brandingSettingsKeys: [keyof PlatformSettings] = [
  'wellesley.branding',
]

export const instanceLegalSettingsKeys: [keyof PlatformSettings] = [
  'wellesley.instance.legal',
]

export const platformSettingsKeys: (keyof PlatformSettings)[] = [
  'wellesley.posts',
  'wellesley.captcha',
  'wellesley.registration',
  'wellesley.access',
  'wellesley.confirmationCode',
  'wellesley.uploads.policy.doc',
  'wellesley.uploads.policy.audio',
  'wellesley.uploads.policy.image',
  'wellesley.uploads.policy.video',
  'wellesley.translation',
  'wellesley.instance.admin',
  'wellesley.instance.domainBlocks',
  'wellesley.instance.contacts',
] as const

export const adminOnlyPlatformSettingsKeys: (keyof PlatformSettings)[] = [
  'wellesley.admin.sms',
  'wellesley.admin.uploads',
  'wellesley.admin.captcha',
  'wellesley.admin.language',
  'wellesley.admin.mediacache',
  'wellesley.admin.translation',
  'wellesley.admin.link_service',
  ...brandingSettingsKeys,
  ...instanceLegalSettingsKeys,
] as const

export const adminOnlyUserSettingsKeysMap = {
  sms: 'wellesley.admin.sms',
  uploads: 'wellesley.admin.uploads',
  captcha: 'wellesley.admin.captcha',
  language: 'wellesley.admin.language',
  mediacache: 'wellesley.admin.mediacache',
  translation: 'wellesley.admin.translation',
  link_service: 'wellesley.admin.link_service',
} satisfies Record<string, keyof PlatformSettings>

export const platformSettingsKeysMap = {
  posts: 'wellesley.posts',
  translation: 'wellesley.translation',
  registration: 'wellesley.registration',
  confirmationCode: 'wellesley.confirmationCode',
  uploadsPolicyDoc: 'wellesley.uploads.policy.doc',
  uploadsPolicyAudio: 'wellesley.uploads.policy.audio',
  uploadsPolicyImage: 'wellesley.uploads.policy.image',
  uploadsPolicyVideo: 'wellesley.uploads.policy.video',
  captcha: 'wellesley.captcha',
  access: 'wellesley.access',
  branding: 'wellesley.branding',
  instanceAdmin: 'wellesley.instance.admin',
  legal: 'wellesley.instance.legal',
  domainBlocks: 'wellesley.instance.domainBlocks',
  contacts: 'wellesley.instance.contacts',
} satisfies Record<string, keyof PlatformSettings>
